var React = require('react');

function LinkedinIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M79.167 0H20.833C9.33 0 0 9.33 0 20.833v58.334C0 90.67 9.33 100 20.833 100h38.334C90.675 100 100 90.67 100 79.167V20.833C100 9.33 90.675 0 79.167 0zM33.333 79.167h-12.5V33.333h12.5v45.834zm-6.25-51.117c-4.025 0-7.291-3.292-7.291-7.35s3.266-7.35 7.291-7.35 7.292 3.292 7.292 7.35-3.262 7.35-7.292 7.35zm56.25 51.117h-12.5v-23.35c0-14.034-16.666-12.971-16.666 0v23.35h-12.5V33.333h12.5v7.355c5.816-10.775 29.166-11.571 29.166 10.316v28.163z","fill":"#fff","fillRule":"nonzero"}));
}

LinkedinIcon.defaultProps = {"className":"mx-1 socialIcons","viewBox":"0 0 100 100","fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"};

module.exports = LinkedinIcon;

LinkedinIcon.default = LinkedinIcon;
